// =============================================================================
// AdminRoutes
//
// Wraps all admin dashboard routes. Redirects non-admin users back to
// the main dashboard. Checks both userType and metadata permissions
// for flexibility as the backend auth matures.
// =============================================================================

import { FunctionComponent } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "src/context/AuthContext";
import { AccountTypes } from "src/utils/types/UserTypes";
import AdminDashboard from "src/pages/dashboard/admin";

const isAdminUser = (user: any): boolean => {
  if (user?.metadata?.permissions?.canAccessAdmin) return true;
  if (user?.userType === AccountTypes.OWNER) return true;
  if (user?.userType === AccountTypes.MANAGER) return true;
  return false;
};

const AdminRoutes: FunctionComponent = () => {
  /*  //TODO: remove this - temp bypass for testing (unable to login as admin user due to backend auth issues)

    return (
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
      </Routes>
    );*/

  const { user } = useAuth();

  //wait for auth to load before checking permissions
  if (user === null) return null;
  
  console.log("user:", user);
  console.log("userType:", user?.userType);
  console.log("metadata:", user?.metadata);

  if (!isAdminUser(user)) return <Navigate to="/dashboard" replace />;

  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
    </Routes>
  );
};

export default AdminRoutes;

